'use client';

import { SwitchInput } from '@app/app/_components/Input/SwitchInput';
import { useTranslations } from 'next-intl';
import { ChangeEvent, useCallback, useState } from 'react';

export function HighContrastModeToggle() {
    const t = useTranslations();

    const [enabled, setEnabled] = useState<boolean>(localStorage.getItem('high-contrast-mode') === 'true');

    const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setEnabled(e.target.checked);

        const isEnabled = e.target.checked ? 'true' : 'false';

        document.body.dataset.accessibilityHighContrastMode = isEnabled;
        localStorage.setItem('high-contrast-mode', isEnabled);
    }, []);

    return (
        <div className="flex items-center justify-between">
            <div>{t('accessibility.highContrastMode')}</div>
            <SwitchInput
                name="highContrastMode"
                defaultChecked={enabled}
                onChange={handleChange}
                ariaLabel={t('accessibility.highContrastMode')}
            />
        </div>
    );
}
